import { useContext, createContext } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var MastheadContext = /*#__PURE__*/createContext(null);
export var MastheadProvider = function MastheadProvider(_ref) {
  var id = _ref.id,
    size = _ref.size,
    creativeAreaAlignment = _ref.creativeAreaAlignment,
    children = _ref.children;
  return /*#__PURE__*/_jsx(MastheadContext.Provider, {
    value: {
      id: id,
      size: size,
      creativeAreaAlignment: creativeAreaAlignment
    },
    children: children
  });
};
export var useMastheadContext = function useMastheadContext() {
  return useContext(MastheadContext);
};